enum TaskType {
    EXPERT = 'expert',
    TEST = 'test',
    TEST_PRO = 'test_pro',
}

export default TaskType;